import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { I18nGuideModalComponent } from './i18n-guide-modal.component';

@Component({
  styleUrls: ['./common.scss'],
  template: `
    <div class="container">
      <glxy-alert class="i18n-alert" type="info" [showAction]="true" actionTitle="i18n update guide" (actionClick)="openI18nGuide()">
        New notification types must be registered in <code>notification-type-definitions.ts</code> and
        <code>en_devel.json</code> in <code>libs/atlas</code> before they render in the atlas settings UI.
      </glxy-alert>

      <notification-manage
        createRoute="/notifications/create"
        editRoute="/notifications/edit/"
        listRoute="/notifications"
        releaseRoute="/notifications/release/"
      />
    </div>
  `,
  standalone: false,
})
export class CreateComponent {
  private dialog = inject(MatDialog);

  openI18nGuide(): void {
    this.dialog.open(I18nGuideModalComponent, { width: '680px' });
  }
}
